// Globals
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { StyledPageWrapper, StyledForm } from './TopProductFormStyles';
import { FormItem, IFormInstance } from '@/components';
import { Button, Select } from '@/ui';

// Models
import { ITopProduct, IProduct } from '@/models/products.model';

// Helpers
import { getProductList, normalizeTopProductValues, TGetTopProductsForm, TopProductsFields } from '../../helpers';
import { useGetTopProductsValidationRules } from '../../hooks';

type TTopProductForm = {
  formInstance: IFormInstance;
  initialValues: ITopProduct | null;
  debouncedFetchProducts: (searchText: string) => void;
  productsList?: IProduct[];
  handleSubmit: (values: TGetTopProductsForm) => Promise<void>;
  isEdit: boolean;
  isLoading: boolean;
};

const TopProductForm = ({
  formInstance,
  debouncedFetchProducts,
  handleSubmit,
  initialValues,
  productsList,
  isEdit,
  isLoading,
}: TTopProductForm) => {
  const { t } = useTranslation(['products']);
  const rules = useGetTopProductsValidationRules();

  const handleSearch = (value: string) => {
    debouncedFetchProducts(value);
  };

  useEffect(() => {
    if (initialValues) {
      formInstance.setFieldsValue(normalizeTopProductValues(initialValues));
    }
  }, [initialValues, formInstance]);

  return (
    <StyledPageWrapper>
      <StyledForm form={formInstance} onFinish={handleSubmit}>
        <FormItem
          name={TopProductsFields.PRODUCT_ID}
          label={t('products_list_product')}
          extra={t('products_article_search')}
          rules={rules[TopProductsFields.PRODUCT_ID]}
        >
          <Select options={getProductList(productsList)} onSearch={handleSearch} showSearch allowClear />
        </FormItem>

        <Button type="primary" htmlType="submit" disabled={isLoading} loading={isLoading}>
          {isEdit ? t('products_list_update') : t('products_list_save')}
        </Button>
      </StyledForm>
    </StyledPageWrapper>
  );
};

export default TopProductForm;
